'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _invertBy3 = require('lodash/invertBy');

var _invertBy4 = _interopRequireDefault(_invertBy3);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _contacts = require('redux/modules/contacts');

var contactsActions = _interopRequireWildcard(_contacts);

var _reactI18next = require('react-i18next');

var _components = require('components');

var _strings = require('helpers/strings');

var _utils = require('helpers/utils');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var SelectContactsList = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    contactsList: state.contacts.contactsListData.contacts,
    contactsListLoading: state.contacts.contactsListLoading,
    contactsListLoaded: state.contacts.contactsListLoaded
  };
}, (0, _extends4.default)({}, contactsActions)), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(SelectContactsList, _Component);

  function SelectContactsList() {
    var _ref;

    (0, _classCallCheck3.default)(this, SelectContactsList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = SelectContactsList.__proto__ || (0, _getPrototypeOf2.default)(SelectContactsList)).call.apply(_ref, [this].concat(args)));

    _this.state = { checkedContacts: {} };
    return _this;
  }

  (0, _createClass3.default)(SelectContactsList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.loadContacts();
    }
  }, {
    key: 'toggleContactChecked',
    value: function toggleContactChecked(e, id) {
      this.setState({
        checkedContacts: (0, _extends4.default)({}, this.state.checkedContacts, (0, _defineProperty3.default)({}, id, !this.state.checkedContacts[id]))
      });
    }
  }, {
    key: 'select',
    value: function select() {
      var onSelect = this.props.onSelect;

      var _ref2 = this.state || {},
          checkedContacts = _ref2.checkedContacts;

      var checkedContactsArr = (0, _invertBy4.default)(checkedContacts).true || []; // eslint-disable-line dot-notation
      onSelect(checkedContactsArr);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          contactsList = _props.contactsList,
          contactsListLoading = _props.contactsListLoading,
          contactsListLoaded = _props.contactsListLoaded;
      var checkedContacts = this.state.checkedContacts;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _components.List,
          null,
          _react2.default.createElement(
            _components.ListItem,
            { fullWidth: true, isTitle: true },
            _react2.default.createElement(
              'div',
              null,
              t('Email')
            ),
            _react2.default.createElement(
              'div',
              null,
              t('Name')
            ),
            _react2.default.createElement('div', null)
          ),
          contactsList.map(function (contact) {
            return _react2.default.createElement(
              _components.ListItem,
              { fullWidth: true, key: contact.id, onClick: function onClick(e) {
                  return _this2.toggleContactChecked(e, contact.id);
                } },
              _react2.default.createElement(
                'div',
                { className: 'break-word' },
                contact.email
              ),
              _react2.default.createElement(
                'div',
                { className: 'break-word' },
                (0, _strings.concat)(' ', contact.name, contact.surname)
              ),
              _react2.default.createElement(
                'div',
                { className: 'text-center' },
                _react2.default.createElement(_components.Checkbox, {
                  className: 'padding-5 inline',
                  checked: checkedContacts[contact.id],
                  onClick: _utils.stopEvent
                })
              )
            );
          })
        ),
        contactsListLoading && _react2.default.createElement(_components.Loader, null),
        contactsListLoaded && _react2.default.createElement(
          'div',
          { className: 'text-right margin-top-20' },
          _react2.default.createElement(
            'button',
            { type: 'button', className: 'btn btn-primary wide', onClick: this.select },
            t('Ok')
          )
        )
      );
    }
  }]);
  return SelectContactsList;
}(_react.Component), _class3.propTypes = {
  contactsList: _propTypes2.default.array,
  contactsListLoaded: _propTypes2.default.bool,
  contactsListLoading: _propTypes2.default.bool,
  loadContacts: _propTypes2.default.func,
  onSelect: _propTypes2.default.func.isRequired,
  t: _propTypes2.default.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'select', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'select'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = SelectContactsList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Contacts/SelectContactsList.js
// module id = 1978
// module chunks = 1